export const siteSettings = {
  name: "Altra Finex",
  link: "https://altrafinex.com/",
  email: "support@altrafinex.com/",
  appLink: "https://app.altrafinex.com/",
};
